import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M8.217 2.553a1.75 1.75 0 0 1 1.566 0l5.105 2.552a.25.25 0 0 0 .224 0l4.105-2.052a1.75 1.75 0 0 1 2.533 1.565v12.764a1.75 1.75 0 0 1-.967 1.565l-5 2.5a1.75 1.75 0 0 1-1.566 0l-5.105-2.553a.25.25 0 0 0-.224 0l-4.105 2.053a1.75 1.75 0 0 1-2.533-1.565V6.618c0-.663.374-1.269.967-1.565zm1.533 1.66 4.467 2.234.033.016v13.323l-4.467-2.233-.033-.016z"
      clipRule="evenodd"
    />
  </>
);

const MapFilled = Icon('map-filled', svgContents);

export default MapFilled;
